export default "__VITE_ASSET__BGSM_oKR__"